import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Key.svg'

export const IconKey = IconSVG as IconComponent
